export const gridStyleHelper = ({ gridHeightBuffer }) => {
  return {
    height: `calc(100vh - ${gridHeightBuffer}px)`,
    width: '100%',
    boxShadow: '0 10px 20px rgba(0,0,0,.1)',
    position: 'relative',
  };
}